import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngxs/store';
import { TokenService } from '../../../../shared/services/token/token.service';
import { SetUserInfo } from '../../../../store/auth/auth.actions';
import { StockyEntryService } from '../../services/stocky-entry.service';
import { ToastrService } from 'ngx-toastr';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-stock-entry-mobile-upload',
  templateUrl: './stock-entry-mobile-upload.component.html',
  styleUrls: ['./stock-entry-mobile-upload.component.sass'],
})
export class StockEntryMobileUploadComponent implements OnInit {
  isLoadingToken = true;
  tokenError: string | null = null;
  isUploading = false;
  uploadedPreviews: string[] = [];
  uploadedUrls: string[] = [];
  deletingIndex: number | null = null;
  tradeId = '';
  lotNumero = '';

  logoUrl = 'assets/svgs/logo.svg';

  constructor(
    private route: ActivatedRoute,
    private tokenService: TokenService,
    private store: Store,
    private stockyEntryService: StockyEntryService,
    private toastr: ToastrService
  ) {}

  async ngOnInit(): Promise<void> {
    this.route.queryParams.subscribe(async ({ t, i, lot }) => {
      this.tradeId = t ?? '';
      this.lotNumero = lot ?? '';

      if (!t || !i) {
        this.tokenError = 'Link inválido. Gere um novo QR Code pela tela de recebimento.';
        this.isLoadingToken = false;
        return;
      }

      await this.loadToken(i);
    });
  }

  private async loadToken(idToken: string): Promise<void> {
    try {
      const result = await this.tokenService
        .get(idToken, 'COLLECT_TVF.getToken')
        .pipe(take(1))
        .toPromise();

      const token = result?.token ?? result?.Token;

      if (token) {
        this.store.dispatch(new SetUserInfo({ token }));
      } else {
        this.tokenError = 'Token inválido. Gere um novo QR Code.';
      }
    } catch {
      this.tokenError = 'Falha ao autenticar. Gere um novo QR Code pela tela de recebimento.';
      this.toastr.error('Erro de autenticação.');
    } finally {
      this.isLoadingToken = false;
    }
  }

  onFileSelected(event: Event): void {
    if (this.isUploading) return;
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    if (!file) return;

    this.isUploading = true;
    input.value = '';
    const reader = new FileReader();
    reader.onload = () => this.uploadFile(file, reader.result as string);
    reader.readAsDataURL(file);
  }

  private uploadFile(file: File, preview: string): void {

    this.stockyEntryService.uploadEvidence(this.tradeId, file).subscribe({
      next: (url: string) => {
        this.uploadedPreviews = [...this.uploadedPreviews, preview];
        this.uploadedUrls = [...this.uploadedUrls, url ?? ''];
        this.isUploading = false;
        this.toastr.success('Foto enviada!');
      },
      error: () => {
        this.isUploading = false;
      },
    });
  }

  removeImage(index: number): void {
    const url = this.uploadedUrls[index];
    this.deletingIndex = index;

    const doRemove = () => {
      this.uploadedPreviews = this.uploadedPreviews.filter((_, i) => i !== index);
      this.uploadedUrls = this.uploadedUrls.filter((_, i) => i !== index);
      this.deletingIndex = null;
    };

    if (!url) {
      doRemove();
      return;
    }

    this.stockyEntryService.deleteEvidence([url]).subscribe({
      next: () => {
        doRemove();
        this.toastr.success('Imagem removida.');
      },
      error: () => {
        this.deletingIndex = null;
        this.toastr.error('Erro ao remover imagem.');
      },
    });
  }
}
